exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Pacifico);", ""]);

// module
exports.push([module.id, "\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// F:/Home/Locker/About-me/about-me1/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!F:/Home/Locker/About-me/about-me1/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!F:/Home/Locker/About-me/about-me1/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles